import { topicWall } from "@/mocks/homeData";

const toneMap: Record<string, { chip: string; ring: string; bar: string }> = {
  primary: {
    chip: "border-primary-200 bg-primary-50 text-primary-800 hover:border-primary-400",
    ring: "bg-primary-500",
    bar: "text-primary-700",
  },
  secondary: {
    chip: "border-secondary-200 bg-secondary-50 text-secondary-800 hover:border-secondary-400",
    ring: "bg-secondary-500",
    bar: "text-secondary-700",
  },
  accent: {
    chip: "border-accent-200 bg-accent-50 text-accent-800 hover:border-accent-400",
    ring: "bg-accent-500",
    bar: "text-accent-700",
  },
};

export default function TopicWall() {
  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full">
            <i className="ri-hashtag"></i>
            <span>话题广场</span>
          </div>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            大家最近都在聊这些话题
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            话题墙按领域分区，点标签就能看到对应的短讯和讨论。
            线索越具体，越容易被整理进持续追踪清单。
          </p>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {topicWall.map((group) => {
            const tone = toneMap[group.tone] ?? toneMap.primary;
            return (
              <div
                key={group.category}
                className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-2.5">
                    <span className={`w-2.5 h-2.5 rounded-full ${tone.ring}`}></span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                      {group.category}
                    </h3>
                  </div>
                  <span className={`text-xs md:text-sm font-medium ${tone.bar}`}>
                    热度 {group.heat}
                  </span>
                </div>

                <div className="mt-5 flex flex-wrap gap-2.5">
                  {group.tags.map((tag) => (
                    <a
                      key={tag}
                      href="#feed"
                      className={`rounded-full border px-3.5 py-1.5 text-xs md:text-sm transition-colors cursor-pointer ${tone.chip}`}
                    >
                      {tag}
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}